import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../components/base/base.component';
import { TextResourceService } from '../../../services/text-resource.service';

@Component({
    // tslint:disable-next-line: component-selector
    selector: '[app-answer]',
    templateUrl: './answer.component.html'
})
export class AnswerComponent extends BaseComponent {
  @Input() question: string;
  @Input() answer: string;

  @Output() goBack = new EventEmitter<void>();

  get editLinkAria() {
    return `${this.resources.editLinkAriaPart} ${this.question}`;
  }

  constructor(textResourceService: TextResourceService) {
    super(textResourceService, 'AnswerComponent');
  }

  goBackTo(ev: Event) {
    ev.preventDefault();
    this.goBack.emit();
  }
}
